import { IGResponse, IOriginDestination, ITraveler } from "@common/models";
import Divider from "@components/general/Divider";
import Icon from "@components/general/Icon";
import Translate from "@service/Translate";
import { FC, Fragment } from "react";
import BoardingPassPrintItem from "./BoardingPassPrintItem";
import { TERMS_CONDITIONS, useApolloQuery } from "@service/graphql";
import { ITermCondition } from "@common/models/CMS";

interface IBoardingPassProps {
    originDestination: IOriginDestination;
    travelers?: ITraveler[];
};

const BoardingPassPrint: FC<IBoardingPassProps> = ({ originDestination, travelers }) => {
    const { tr } = Translate;
    const { data, loading } = useApolloQuery<IGResponse<ITermCondition[]>>(TERMS_CONDITIONS, { variables: { code: "boardingPass" } });

    return (
        <div className="check-in-boarding-pass-print">
            {travelers?.map((traveler, index) =>
                <Fragment key={index}>
                    {
                        index % 2 === 0 ?
                            <section className="boarding-pass-print-caution">
                                <div className="check-in-boarding-pass-print-item">
                                    <div className="check-in-boarding-pass-print-item-container row spa-0">
                                        <aside className="col-1-4 flex flex-center">
                                            <div className="flex flex-grow column-direction flex-center aside-section">
                                                <Icon name="icon-alert-circle-outline" color="danger" size="75px" />
                                                <div className="title">{tr("attention")}</div>
                                            </div>
                                        </aside>
                                        <Divider orientation="vertical" mode="perforation" />
                                        <main className="col-3-4 flex flex-center">
                                            {loading ? '' : <div className="flex-grow main-section" contentEditable={false} dangerouslySetInnerHTML={{ __html: data?.termsConditions[0]?.htmlBody?.html || "" }} />}
                                        </main>
                                    </div>
                                </div>
                                <Divider orientation="horizontal" mode="scissor" />
                            </section>
                            : ""
                    }
                    <section className="boarding-pass-print-section" >
                        <BoardingPassPrintItem traveler={traveler} originDestination={originDestination} />
                        <Divider orientation="horizontal" mode="scissor" />
                    </section>
                </Fragment>

            )}
        </div>

    )
}

export default BoardingPassPrint;